import {
  DRAFT_STATUS_ADD_REQUEST,
  DRAFT_STATUS_ADD_REQUEST_FAILURE,
  DRAFT_STATUS_ADD_REQUEST_SUCCESS,
  DRAFT_STATUS_CLEAN_REQUEST,
  DRAFT_STATUS_FETCH_REQUEST,
  DRAFT_STATUS_FETCH_REQUEST_FAILURE,
  DRAFT_STATUS_FETCH_REQUEST_SUCCESS,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  pagination: {},
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const draftStatusReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case DRAFT_STATUS_FETCH_REQUEST:
    case DRAFT_STATUS_ADD_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case DRAFT_STATUS_FETCH_REQUEST_SUCCESS:
    case DRAFT_STATUS_ADD_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        payload: action.data,
        errors: {},
        pagination: {
          current: action.data.currentPage || 0,
          pageSize: action.data.pageSize || 0,
          total: action.data.totalRecord || 0,
          totalPage: action.data.totalPage || 0,
          pageSizeOptions: ['5', '10', '15', '20'],
          showSizeChanger: true,
        },
      });

    case DRAFT_STATUS_FETCH_REQUEST_FAILURE:
    case DRAFT_STATUS_ADD_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
        pagination: {},
      });

    case DRAFT_STATUS_CLEAN_REQUEST:
      return Object.assign({}, state, {
        loading: false,
        errors: {},
        payload: [],
      });

    default:
      return state;
  }
};

export default draftStatusReducer;
